import React from 'react';
import { SearchHeader } from 'src/components/shared/AppHeaders/SearchHeader';
import { BasicHeader, WelcomeHeader } from 'src/components/shared/AppHeaders';
const basicPagesRoutes = [];
const welcomePagesRoutes = ['/resident_portal'];
const basicHeaderRoutes = [...basicPagesRoutes];
const welcomeHeaderRoutes = [...welcomePagesRoutes];
export default function getHeaderVariant(route, toggleSidebar) {
  if (basicHeaderRoutes.includes(route)) return /*#__PURE__*/React.createElement(BasicHeader, {
    toggleSidebar: toggleSidebar
  });
  if (welcomeHeaderRoutes.includes(route)) return /*#__PURE__*/React.createElement(WelcomeHeader, null);
  return /*#__PURE__*/React.createElement(SearchHeader, {
    toggleSidebar: toggleSidebar
  });
}